import script from "./TarVue.vue?vue&type=script&lang=ts&setup=true"
export * from "./TarVue.vue?vue&type=script&lang=ts&setup=true"

import "./TarVue.vue?vue&type=style&index=0&id=96c1bbce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96c1bbce"]])

export default __exports__